import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import PropTypes from 'prop-types';
import { getSessionByKey, GetUserFullName, useGetPathProtocol } from 'helpers';
import { TE } from 'appconstants';
import { ProtApprovalInfoColumns } from '../gridcolumns';

const ProtAppInfo = ({
  protocolNumber, docHandler, getToken
}) => (
  <GridTable
    tag={`${TE.ID}protapprovalinfo${TE.TABLE}`}
    title="Protocol Approval Information"
    exportTitle={`Protocol Approval Information-${useGetPathProtocol()}-CIRB`}
    remoteUrl={`protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/number/${protocolNumber}/approvals`}
    rowEvents={[docHandler]}
    getToken={getToken}
    columns={ProtApprovalInfoColumns}
    defaultSorts={[{
      field: 'approvalDate',
      dir: 'desc'
    }]}
    user={GetUserFullName()}
    enableToolbar
    filterable
    sortable
    recordPerPage={10}
    toPdf={false}
  />
);

ProtAppInfo.propTypes = {
  protocolNumber: PropTypes.string.isRequired,
  docHandler: PropTypes.func.isRequired,
  getToken: PropTypes.func.isRequired
};

export { ProtAppInfo };
